import { render, staticRenderFns } from "./AssignRoleToUser.vue?vue&type=template&id=d2bb803e&scoped=true&"
import script from "./AssignRoleToUser.vue?vue&type=script&lang=js&"
export * from "./AssignRoleToUser.vue?vue&type=script&lang=js&"
import style0 from "./AssignRoleToUser.vue?vue&type=style&index=0&id=d2bb803e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2bb803e",
  null
  
)

export default component.exports